module.exports = __webpack_public_path__ + "img/738-64a809.png";